import React from 'react';
import { FormField } from '@iris-platform/iris-react-ui';
// import ChangeDomainDetails from './../Containers/editDomains'
import withStyles from '@material-ui/core/styles/withStyles';
import Table, {
  TableCell, TableHead, TableRow, TableBody,
} from 'material-ui/Table';
import Panel from '../../../components/Panel';


const styles = () => ({
  root: {
    opacity: '1',
    border: '1px solid #ccc',
    '&:focus-within': {
      border: '1px solid #66afe9',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  btn: {
    marginTop: '10px',
  },
  seltAll: {
    fontSize: '14px',
    display: 'inline-block',
    marginLeft: '2px',
    verticalAlign: 'middle',
  },
  table: {
    marginTop: '30px',
  },
  tableHead: {
    height: '34px',
  },
  cancelBtn: {
    position: 'absolute',
    right: '20px',
    fontSize: '24px',
    cursor: 'pointer',
  },
  team: {
    color: '#2980b9',
    cursor: 'pointer',
    fontSize: '16px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  addUserField: {
    width: '70%',
    display: 'inline-block',
  },
  filterLabel: {
    marginTop: '20px',
    color: '#2980b9',
  },
});


const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#2980b9',
    color: theme.palette.common.white,
    fontWeight: 'bold',
    fontSize: '16px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  body: {
    fontSize: '16px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
}))(TableCell);

const Domains = (props) => {
  const {
    domainList, editTeamDetails, onCloseEdit, selectedDomain, classes,
  } = props;
  return (
    <div className={classes.pageWtrapper}>
      <Panel
        id="jiraDomainsPanel"
        title={(
        <div>
          {selectedDomain ? selectedDomain.domain : 'Domain'}
          {selectedDomain && <span onClick={onCloseEdit} className={classes.cancelBtn}>x</span>}
        </div>
      )}
      >
        {selectedDomain
          ? (
            <div className={classes.editTeamDetails}>
              Edit
            </div>
          )
          : (
            <div className={classes.listContainer}>
              <FormField classes={{ root: classes.root }} onChange={props.domainSearch} placeholder="Search for Domains" />
              <div className={classes.filterLabel}>
                Total number of domains based on current filter:
                {domainList.length}
              </div>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow classes={{ root: classes.tableHead }}>
                    <CustomTableCell>Team</CustomTableCell>
                    <CustomTableCell>Created On</CustomTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {domainList.map((item, index) => (
                    <TableRow className={classes.row} key={index}>
                      <CustomTableCell><a className={classes.team} onClick={() => editTeamDetails(item, index)}>{item.domain}</a></CustomTableCell>
                      <CustomTableCell>{item.createdOn}</CustomTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
      </Panel>
    </div>
  );
};

export default withStyles(styles)(Domains);
